import {
  pathAssetsGlobal,
  pathAssetsJavelin
} from '@/globals/globalvariables'
import type { LoaderDataTypes } from '@powerplay/core-minigames'
import { ModelsNames } from '../types'

// Hlavny priecinok s modelmi
const modelsDirJavelin = `${pathAssetsJavelin}/models/`
const modelsDirGlobal = `${pathAssetsGlobal}/models/`

/**
 * Konfig pre modely
 */
export const modelsConfig: LoaderDataTypes = {
  [ModelsNames.athlete]: {
    ext: 'glb',
    version: 250217,
    femaleVersion: 241113,
    genderActive: true,
    dir: modelsDirJavelin,
    mainMeshNames: [ModelsNames.athlete]
  },
  [ModelsNames.env]: { // specialny env pre javelin veci
    ext: 'glb',
    version: 241217,
    dir: modelsDirJavelin
  },
  [ModelsNames.stadium]: { // globalne stadion veci
    ext: 'glb',
    version: 2412174,
    dir: modelsDirGlobal
  },
  [ModelsNames.envDynamic]: { // specialne veci s nastavovanim farby a pod, kde nie je pouzity DRACO loader
    ext: 'glb',
    version: 241017,
    dir: modelsDirJavelin
  },
  [ModelsNames.trackLines]: {
    ext: 'glb',
    version: 241016,
    dir: modelsDirJavelin
  },
  // [ModelsNames.cameraBoxes]: {
  //   ext: 'glb',
  //   version: 241128,
  //   dir: modelsDirJavelin,
  // }

}
